import { Directive, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { cn } from '@valk-nx/core/lib/core';

@Directive()
export abstract class BaseDirective {
	readonly translate = inject(TranslateService);
	language: string;

	cn = cn;

	constructor() {
		this.language =
			this.translate?.currentLang ?? this.translate?.defaultLang;
	}
}
